<template>
  <div class="wrapper">
    <div class="profile">
        <router-view></router-view>
    </div>
    <div class="members-heading">
        <h3>Residents</h3>
        +
    </div>
    <div class="searchbox">
      <input type="text" placeholder="Smith" />
    </div>
    <div class="members-list">
      <!-- resident -->
        <div v-bind:key="resident" v-for="resident in residents" class="resident">
            <img src="https://www.w3schools.com/howto/img_avatar.png" class="avatar"/>
          <div class="resident-details">
            <p class="resident-name">{{resident.name}}</p>
            <p class="resident-block">{{resident.block}}</p>
          </div>
        </div> <!-- resident end -->

    </div>
  </div>
</template>

<script>

export default {
    name: 'residents',
    data() {
        return {
            residents: [
                {
                    name: 'asad chingari',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'danial khan kabali',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'mohsin kino',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'fatima danger zone',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'shahzain',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'asad',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'asad',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'asad',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'asad',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'asad',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'asad',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'asad',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'asad',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'asad',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'asad',
                    block: 'Devusta OU',
                    avatar: ''
                },
                {
                    name: 'asad',
                    block: 'Devusta OU',
                    avatar: ''
                }
            ]
        }
    }
};
</script>

<style lang="scss" scoped>

</style>
